import { useDraftMode } from '@/ui/pages/pipelineConfigPage/context/DraftModeContext';
import {
  Button,
  Modal,
  ModalProps,
  Progress,
  UntitledLoading,
} from '@payaca/ambrosia';
import { FC } from 'react';

type Props = Pick<ModalProps, 'isOpen' | 'onClose'>;

const SaveChangesModal: FC<Props> = ({ isOpen, onClose }) => {
  const { phase, pendingCount, totalQueuedMutations, commit } = useDraftMode();

  const isCommitting = phase.startsWith('committing');

  return (
    <Modal
      title="Save changes"
      isOpen={isOpen || isCommitting}
      onClose={isCommitting ? undefined : onClose}
    >
      {isCommitting ? (
        <Modal.Body className="space-y-2.5">
          <p>Processing your changes, do not close your browser.</p>

          <div className="flex justify-between items-center gap-4">
            <UntitledLoading />

            <Progress
              bars={[
                {
                  progress: totalQueuedMutations - pendingCount,
                  total: totalQueuedMutations,
                  colour: 'blue',
                },
              ]}
              size="lg"
            />

            <p className="whitespace-nowrap">
              {totalQueuedMutations - pendingCount} / {totalQueuedMutations}
            </p>
          </div>
        </Modal.Body>
      ) : (
        <>
          <Modal.Body>
            Are you sure you want to save all changes to this pipeline?
          </Modal.Body>
          <Modal.Footer>
            <Modal.Footer.Actions>
              <Button variant="outline" onClick={() => onClose?.()}>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  void commit();
                  onClose?.();
                }}
              >
                Save
              </Button>
            </Modal.Footer.Actions>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default SaveChangesModal;
